<template>
    <div class="form">
        <div id="mc_embed_signup">
            <form
                action="https://smashdelta.us20.list-manage.com/subscribe/post?u=2c03bcbd24f1b7a194b2e5dca&amp;id=5baa9a04c7&SIGNUP=Strategy-Blueprint"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
            >
                <div id="mc_embed_signup_scroll">
                    <h2 class="sign-up">REGISTER</h2>

                    <p class="sign-up-text">
                        Register to explore {{ signUpText.toLowerCase() }} with
                        us in more detail - and learn how {{ itThey }} fits in
                        to our holistic data strategies. Also, become a member
                        of our Smash Delta Community for access to our latest
                        research and exciting events. You can unsubscribe at any
                        time.
                    </p>

                    <div class="mc-field-group">
                        <label for="mce-EMAIL">
                            Email Address
                            <span class="asterisk">*</span>
                        </label>
                        <input
                            type="email"
                            v-model="email"
                            name="EMAIL"
                            class="required email"
                            id="mce-EMAIL"
                        />
                        <transition name="fade">
                            <div v-show="fieldMessage">
                                <p class="permission-needed">
                                    {{ fieldMessage }}
                                </p>
                            </div>
                        </transition>
                    </div>
                    <div class="row">
                        <div class="column">
                            <div class="mc-field-group">
                                <label for="mce-FNAME">First Name</label>
                                <input
                                    type="text"
                                    value
                                    name="FNAME"
                                    class
                                    id="mce-FNAME"
                                />
                            </div>
                        </div>
                        <div class="column">
                            <div class="mc-field-group">
                                <label for="mce-LNAME">Last Name</label>
                                <input
                                    type="text"
                                    value
                                    name="LNAME"
                                    class
                                    id="mce-LNAME"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <div class="mc-field-group">
                                <label for="mce-MMERGE5">Company</label>
                                <input
                                    type="text"
                                    value
                                    name="MMERGE5"
                                    class
                                    id="mce-MMERGE5"
                                />
                            </div>
                        </div>
                        <div class="column">
                            <div class="mc-field-group">
                                <label for="mce-MMERGE7">Role</label>
                                <input
                                    type="text"
                                    name="MMERGE7"
                                    class
                                    id="mce-MMERGE7"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        style="position: absolute; left: -5000px;"
                        aria-hidden="true"
                    >
                        <input
                            type="text"
                            name="b_2c03bcbd24f1b7a194b2e5dca_cfe9482a38"
                            tabindex="-1"
                            value
                        />
                    </div>
                    <div class="clear">
                        <input
                            type="submit"
                            value="Submit"
                            name="subscribe"
                            id="mc-embedded-subscribe"
                            class="button"
                            :class="{ disabled: !readyToSubmit }"
                            @click="submitHandler"
                        />
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            email: '',
            fieldMessage: ''
        }
    },

    computed: {
        ...mapState(['signUpText']),

        emailValid() {
            return this.validateEmail(this.email)
        },

        readyToSubmit() {
            return this.emailValid
        }
    },

    methods: {
        updateMessage() {
            this.fieldMessage = 'Please provide a valid email.'
        },

        submitHandler(e) {
            if (this.readyToSubmit) {
                this.$emit('close')
            } else {
                e.preventDefault()
                this.updateMessage()
            }
        },

        // taken from https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
        validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        }
    }
}
</script>

<style lang="stylus" scoped>
#mc-embedded-subscribe-form
    // max-width: 460px;
    padding: 1em
    box-sizing: border-box
    color: sd-black

    @media (min-width: medium)
        padding: 2em

/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
#mc-embedded-subscribe-form input[type='checkbox']
    display: inline
    width: auto
    margin-right: 10px

#mergeRow-gdpr fieldset label
    font-weight: normal

#mc-embedded-subscribe-form .mc_fieldset
    border: none
    min-height: 0px
    padding-bottom: 0px

.mc-field-group
    display: flex
    flex-direction: column
    margin-bottom: 8px

.asterisk
    color: sd-orange

.indicates-required
    font-size: 0.75em
    color: #555
    margin-bottom: 1em

// ----- Marketing permissions -----
.content__gdpr--text
    margin: 0 0 0.5em 0
    font-size: 0.5em
    line-height: 1
    color: #555555

// ------ Email checkbox ------
.content__gdpr .checkbox span
    font-family: 'Heebo'
    text-transform: uppercase
    letter-spacing: 0.1em
    color: sd-black

// ----- Subscribe button -----
#mc-embedded-subscribe
    width: 100%
    margin-top: 1rem
    margin-bottom: 0
    font-family: 'Heebo'
    border-radius: 0
    color: sd-white
    border: 2px solid sd-blue
    background-color: sd-blue

    // background-color: sd-white;
    &:hover
        background-color: #2f4ce8
        border-color: #2f4ce8
        color: sd-white

.disabled
    border-color: #a2b0ff !important
    background-color: #a2b0ff !important

.prompt
    // border: 1px solid rgb(241, 79, 29) !important;
    // border-radius: 2px;

.permission-needed
    font-weight: 400
    margin-bottom: 0
    color: sd-orange

.sign-up
    font-size: 18px
    margin-bottom: 0.25em
    margin-top: 0

.sign-up-text
    margin-top: 0

/* Forms
–––––––––––––––––––––––––––––––––––––––––––––––––– */
input[type='email'], input[type='text'], input[type='tel']
    height: 2em
    line-height: 2em
    padding: 0 0.5em /* The 6px vertically centers text on FF, ignored by Webkit */
    background-color: #fff
    border-radius: 4px
    box-shadow: none
    box-sizing: border-box
    border: 1px solid #ccc

/* Removes awkward default styles on some inputs for iOS */
input[type='email'], input[type='number'], input[type='search'], input[type='text'], input[type='tel'], input[type='url'], input[type='password'], textarea
    -webkit-appearance: none
    -moz-appearance: none
    appearance: none

input[type='email']:focus, input[type='number']:focus, input[type='search']:focus, input[type='text']:focus, input[type='tel']:focus, input[type='url']:focus, input[type='password']:focus, textarea:focus, select:focus
    border: 1px solid sd-blue
    outline: 0

label, legend
    display: block
    margin-bottom: 0.375em
    font-weight: 600
    color: #555
    font-size: 0.75em

fieldset
    padding: 0
    border-width: 0

input[type='checkbox'], input[type='radio']
    display: inline

label > .label-body
    display: inline-block
    margin-left: 0.5rem
    font-weight: normal

.column
    width: 100%
    float: left
    box-sizing: border-box

    @media (min-width: 500px)
        width: 48%
        margin-left: 4%

        &:first-child
            margin-left: 0

/* Clearing
–––––––––––––––––––––––––––––––––––––––––––––––––– */
/* Self Clearing Goodness */
.container:after, .row:after, .u-cf
    content: ''
    display: table
    clear: both
</style>
